import { Round } from 'components/FormattedAmount/components/Round/Round';
import type { Currency } from 'models/currency';
import type React from 'react';
import { connect } from 'react-redux';
import type { RootState } from 'reducers/types';
import { getCurrency } from 'selectors/entities/currencies/currencies';
import { formatAmount } from 'utils/money/money';

type AmountProps = {
  getCurrency: (code: string) => Currency;
  currency: string;
  render?: (formattedAmount: { formattedAmount: string }) => React.ReactNode;
  value: number;
};

const AmountComponent = ({
  getCurrency,
  currency,
  render,
  value,
}: AmountProps) => {
  const currencyObject = getCurrency(currency);

  if (!currencyObject) {
    return null;
  }
  const formattedAmount = formatAmount(value, currencyObject);

  return render && typeof render === 'function'
    ? render({ formattedAmount })
    : formattedAmount;
};

AmountComponent.Round = Round;

const mapStateToProps = (state: RootState) => ({
  getCurrency: (code: string) => getCurrency(state, code),
});

export const Amount = connect(mapStateToProps)(AmountComponent);
